<template>
    <div class="tree-select-option" :id="id">
        <ion-icon :name="iconName" v-show="hasVisibleChildren" @click="toggleChildrenVisibility"></ion-icon>
        <label :class="{disabled: option.isDisabled}">
            <input
                :type="isMultiple? 'checkbox' : 'radio'"
                :value="option.id"
                :name="actualName"
                @input="toggle"
                :checked="option.checked"
                :disabled="option.isDisabled"
                v-if="isMultiple || !hasChildren"
                ref="input"
            />
            <span v-if="htmlTitle" v-html="option.title"></span>
            <template v-else>
                <strong v-if="!hasChildren">{{ option.title }}</strong>
                <span v-else>{{ option.title }}</span>
            </template>
        </label>
        <ul v-if="hasChildren" v-show="hasVisibleChildren && option.isChildrenVisible">
            <li v-for="childOption in option.children" :key="childOption.value" v-show="childOption.visible">
                <select-option
                    :option="childOption"
                    :name="name"
                    :parent-auto-check="parentAutoCheck"
                    :is-multiple="isMultiple"
                    @check="checkChildren"
                    :uid="uid"
                ></select-option>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "select-option",
        props: {
            option: {
                type: Object,
            },
            name: String,
            parentAutoCheck: {
                type: Boolean,
                default: false
            },
            isMultiple: {
                type: Boolean,
                default: true
            },
            htmlTitle: {
                type: Boolean,
                default: false
            },
            uid: {
                type: String,
                default: ''
            },
            onlyEndNodes: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            toggle(checkChildren = true) {
                const isChecked = !this.option.checked;
                this.check(this.option, isChecked, true, checkChildren);
            },
            check(option, checkStatus, isDirectChild, checkChildren) {
                this.$emit('check', option, checkStatus, isDirectChild);

                if (checkChildren) {
                    option.children && option.children.forEach(childOption => {
                        this.check(childOption, checkStatus, false, true);
                    });
                }
            },
            toggleChildrenVisibility() {
                this.option.isChildrenVisible = !this.option.isChildrenVisible;
            },
            checkChildren(option, isChecked, isDirectChild) {
                if (isDirectChild) {
                    this.$nextTick(() => {
                        const childrenSelectedCount = this.option.children.filter(child => child.checked).length,
                            allChildrenSelected = childrenSelectedCount >= this.option.children.length;

                        this.$refs.input.indeterminate = childrenSelectedCount && !allChildrenSelected;
                        if (!this.option.checked && allChildrenSelected && this.parentAutoCheck || this.option.checked && !allChildrenSelected) {
                            this.toggle(false);
                        }
                    })
                }

                this.$emit('check', option, isChecked, false)
            }
        },
        computed: {
            hasChildren() {
                return this.option.children && this.option.children.length;
            },
            hasVisibleChildren() {
                return this.option.children && this.option.children.filter(item => item.visible).length;
            },
            iconName() {
                return this.option.isChildrenVisible ? 'remove-circle-outline' : 'add-circle-outline'
            },
            id() {
                return this.uid + '_' + this.option.id;
            },
            actualName() {
                return this.onlyEndNodes && this.option.children && this.option.children.length ? '' : this.name;
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "resources/sass/_variables";

    .tree-select-option {
        position: relative;

        ion-icon {
            font-size: $font-size-small;
            line-height: 14px;
            height: 14px;
            position: absolute;
            top: 6px;
            color: #666;
            cursor: pointer;
        }

        label {
            margin-left: 12px;
            padding: 4px 0 4px 5px;
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            margin-bottom: 3px;

            &:hover {
                background: $info-background-color;
                color: $info-text-color;

                &.disabled {
                    cursor: not-allowed;
                    background: #ccc;
                    color: #000;
                }
            }
        }

        input {
            margin-right: 5px;
        }

        ul {
            margin-left: 15px;
            margin-right: 0;
        }
    }
</style>
